import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Id = iotsUtils.fromList(constants.wholeHouse.material.priceUnit.ids);

export const CommonId = iotsUtils.fromList(constants.wholeHouse.material.priceUnit.commonIds);

export const PackId = iotsUtils.fromList(constants.wholeHouse.material.priceUnit.packIds);
